export default __webpack_public_path__ + "bc4fc083a32c6b19eb854f3104009aa1.svg";